/**
 * RPDM W1-D · Project Summary Landing (structural placeholder only).
 *
 * SCOPE: Renders three placeholder widgets — Overview · Timeline ·
 * Activity. Each widget carries a "Preview surface — content lands
 * in W2+" caption. NO real reports, NO charts, NO Gantt, NO business
 * logic. The workspace shell owns the read of `GET /projects/engagement/:id`
 * and passes a normalised `view` to us.
 *
 * Route: /projects/:id      (when master + summary_landing flags both ON)
 */
import ProjectWorkspaceShell from "./ProjectWorkspaceShell";
import WorkspaceWidgetShell from "./WorkspaceWidgetShell";

export default function ProjectSummaryLanding() {
    return (
        <ProjectWorkspaceShell>
            {(view) => (
                <div
                    className="mx-auto grid max-w-6xl gap-5 md:grid-cols-2"
                    data-testid="rpdm-summary-landing"
                >
                    <WorkspaceWidgetShell
                        title="Overview"
                        description="Top-level project posture."
                        testId="rpdm-widget-overview"
                    >
                        <dl className="grid grid-cols-3 gap-3 text-xs">
                            <div>
                                <dt className="text-slate-500">Engagement</dt>
                                <dd className="font-mono text-slate-800" data-testid="rpdm-overview-code">
                                    {view.code || "—"}
                                </dd>
                            </div>
                            <div>
                                <dt className="text-slate-500">Type</dt>
                                <dd className="capitalize text-slate-800" data-testid="rpdm-overview-kind">
                                    {view.kind || "—"}
                                </dd>
                            </div>
                            <div>
                                <dt className="text-slate-500">State</dt>
                                <dd className="capitalize text-slate-800" data-testid="rpdm-overview-state">
                                    {view.state || "—"}
                                </dd>
                            </div>
                        </dl>
                        <p className="mt-3 text-xs text-slate-500">
                            Preview surface — widget content lands in W2+ (rollups,
                            approval status, next action, PSA-owned signals).
                        </p>
                    </WorkspaceWidgetShell>

                    <WorkspaceWidgetShell
                        title="Timeline"
                        description="Delivery milestones — schema arrives in W2+."
                        testId="rpdm-widget-timeline"
                    >
                        <p className="text-xs text-slate-500">
                            No milestone series available in W1-D. The delivery
                            surface at
                            {" "}
                            <code className="rounded bg-slate-100 px-1 py-0.5">/projects/{view.id}/delivery</code>
                            {" "}
                            continues to render today&apos;s execution page unchanged.
                        </p>
                    </WorkspaceWidgetShell>

                    <WorkspaceWidgetShell
                        title="Recent Activity"
                        description="Cross-work-item audit stream — enabled in W2+."
                        testId="rpdm-widget-activity"
                    >
                        <p className="text-xs text-slate-500">
                            The workspace activity feed is a placeholder in W1-D.
                            Existing per-work-item audit history remains accessible
                            from the execution surface.
                        </p>
                    </WorkspaceWidgetShell>

                    <WorkspaceWidgetShell
                        title="Next Actions"
                        description="Assignee-driven queue — arrives with W2."
                        testId="rpdm-widget-next-actions"
                    >
                        <p className="text-xs text-slate-500">
                            Preview surface. Live assignment aggregation lives on
                            the existing /projects/my-work page today.
                        </p>
                    </WorkspaceWidgetShell>
                </div>
            )}
        </ProjectWorkspaceShell>
    );
}
